import { useTranslation } from 'react-i18next'
import { Trans } from 'react-i18next'

import dayjs from 'dayjs'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getDiffDays } from './helpers'

const UpdatedTimeText = ({ modified }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const diffDays = getDiffDays(dayjs(), dayjs(modified))

  if (diffDays === 0) {
    return (
      <Text type="bodySRegular" color={theme.colors.text.subtle}>
        ({t('Actualizado recientemente')})
      </Text>
    )
  }

  return (
    <Text type="bodySRegular" color={theme.colors.text.subtle}>
      <Trans i18nKey="updatedAgo" values={{ time: diffDays > 1 ? `${diffDays} days` : `${diffDays} day` }}>
        (Actualizado hace {diffDays > 1 ? `${diffDays} días` : `${diffDays} día`})
      </Trans>
    </Text>
  )
}

export default UpdatedTimeText
